<template>
    <div class="form-group col-12">
        <link-explanation />

        <div v-for="(item, index) in content.tiles" :key="index">
            <h6
                class="col-12 mt-4 p-2 bg-light text-uppercase text-center align-items-center d-flex"
            >
                <button
                    v-if="content.tiles.length > 1"
                    class="col-md-1 col-sm-2 col-3 btn btn-danger waves-effect waves-ligh mr-3"
                    type="button"
                    @click="removeItem(index)"
                >
                    <i class="far fa-trash-alt" />
                </button>
                #{{ index + 1 }}
            </h6>
            <div class="row">
                <div class="form-group col-md-6 col-12">
                    <label :for="`title_${index}`">Title</label>
                    <input
                        :id="`title_${index}`"
                        v-model="item.title"
                        class="form-control"
                        :class="{
                            'is-invalid': v.tiles.$each[index].title.$error
                        }"
                        dir="auto"
                    />
                </div>
                <div class="form-group col-md-6 col-12">
                    <label :for="`redirect_${index}`">Redirect</label>
                    <input
                        :id="`redirect_${index}`"
                        v-model="item.redirect"
                        class="form-control"
                        :class="{
                            'is-invalid': v.tiles.$each[index].redirect.$error
                        }"
                        dir="auto"
                    />
                </div>
                <div class="form-group col-12">
                    <label :for="`image_${index}`">Image</label>
                    <media-chooser
                        :id="`image_${index}`"
                        v-model="item.image"
                        type="image"
                        :error-border="v.tiles.$each[index].image.$error"
                    />
                </div>
                <div class="form-group col-12">
                    <label :for="`premiumOnly_${index}`">
                        Is for premium users
                    </label>
                    <b-form-checkbox
                        :id="`premiumOnly_${index}`"
                        v-model="item.premiumOnly"
                        switch
                    />
                </div>
                <div v-if="item.premiumOnly" class="form-group col-12">
                    <label :for="`premiumOnlyImage_${index}`">
                        Premium only image
                    </label>
                    <media-chooser
                        :id="`premiumOnlyImage_${index}`"
                        v-model="item.premiumOnlyImage"
                        type="image"
                        :error-border="
                            v.tiles.$each[index].premiumOnlyImage.$error
                        "
                    />
                </div>
            </div>
        </div>
        <button
            class="btn btn-success waves-effect waves-light mr-1 mt-4"
            type="button"
            @click="addItem"
        >
            <i class="fas fa-plus-circle" /> Add Item
        </button>
    </div>
</template>

<script>
import LinkExplanation from '@/components/common/LinkExplanation';

export default {
    components: {
        LinkExplanation
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        v: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            content: {
                tiles: []
            }
        };
    },

    watch: {
        content() {
            this.$emit('input', this.content);
        }
    },

    mounted() {
        this.content = { ...this.content, ...this.value };

        if (!this.content.tiles.length) {
            this.addItem();
        }
    },

    methods: {
        addItem() {
            this.content.tiles.push({
                image: '',
                title: '',
                redirect: '',
                premiumOnly: false
            });
        },

        removeItem(index) {
            this.content.tiles.splice(index, 1);
        }
    }
};
</script>
